// storageUtils.js
export const getPayrollData = () => {
    const data = localStorage.getItem('payrollData');
    return data ? JSON.parse(data) : [];
  };
  
  export const savePayrollData = (data) => {
    localStorage.setItem('payrollData', JSON.stringify(data));
  };